import React, { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import * as terapiaService from "../services/terapiaService";
import * as filialService from "../services/filialService";
import { Grid, Typography, TextField, Button, Dialog, DialogActions
    , DialogContent, DialogTitle, Select, InputLabel, FormControl
    , CircularProgress, Hidden, Box } from '@mui/material';
import { DataGrid, GridToolbarContainer, GridOverlay
    , GridToolbarFilterButton } from "@mui/x-data-grid";
import { Search as IconSearch } from "@mui/icons-material";
import { PaperComponentDraggable } from "./PaperComponentDraggable";

// Busqueda de terapias. Se usa para referenciar la terapia al que pertenece
// un plan de terapia: una misma terapia puede tener mas de un plan, asi que
// el plan no se puede deducir de la terapia, hay que elegirla explicitamente.
const TerapiaSearch = (props) => {
    const idFilialUsuario = useSelector((state) => state.seguridad?.idFilial) || 0;
    const [cargando, setCargando] = useState(false);
    const [listFiliales, setListFiliales] = useState([{ id: 0, descripcion: "" }]);
    const [filters, setFilters] = useState({
        idFilial: idFilialUsuario > 0 ? idFilialUsuario : 0,
        member: "",
        therapist: "",
    });
    const [results, setResults] = useState([]);
    // Fila resaltada con un clic. Se elige con doble clic o con el boton Aceptar.
    const [filaElegida, setFilaElegida] = useState(null);

    const fetchResults = async () => {
        setCargando(true);

        await terapiaService.getsTerapiaResumenView({
            idFilial: filters.idFilial,
            member: filters.member,
            therapist: filters.therapist,
            idEstado: 2,
        })
            .then((data) => {
                setResults(data);
                setFilaElegida(null);
                setCargando(false);
            })
            .catch((err) => {
                setCargando(false);
                console.log("Err: ", err);
            });
    }
    const fetchFiliales = useCallback(async () => {
        await filialService.getFilialesList()
            .then((data) => {
                setListFiliales(filialService.soloFilialDelUsuario(data, idFilialUsuario));
            })
            .catch((err) => {
                console.log("Err: ", err);
            });
    }, [])

    useEffect(() => {
        fetchFiliales();
        fetchResults();
    }, [])

    function CustomToolbar() {
        return (
            <GridToolbarContainer>
                <GridToolbarFilterButton />
            </GridToolbarContainer>
        );
    }

    function CustomLoadingOverlay() {
        return (
            <GridOverlay>
                <Box sx={{ display: "flex", "& > * + *": { ml: 2 } }}>
                    <CircularProgress />
                </Box>
            </GridOverlay>
        );
    }

    const columns = [
        { field: 'codigoServicio', headerName: 'Codigo', width: 80, sortable: false },
        { field: 'tipo', headerName: 'Tipo', width: 100, sortable: false },
        { field: 'participante', headerName: 'Participante', width: 180, sortable: true },
        { field: 'terapeuta', headerName: 'Terapeuta', width: 180, sortable: true },
        { field: 'filial', headerName: 'Filial', width: 100, sortable: false },
        { field: 'horario', headerName: 'Horario', width: 180, sortable: false },
        { field: 'estado', headerName: 'Estado', width: 80, sortable: false, align: 'center' },
    ];

    return (
        <Dialog
            open={props.open}
            onClose={props.openClose}
            fullWidth={true}
            maxWidth={"md"}
            PaperComponent={PaperComponentDraggable}
        >
            <DialogTitle
                id="draggable-dialog-title"
                style={{ cursor: "move" }}>
                <Typography>
                    Buscar Terapia
                </Typography>
            </DialogTitle>
            <DialogContent style={{ minHeight: "30px", maxHeight: "450px" }} >
                <Grid container item xs={12} sm={12} spacing={2} padding={1} >
                    <Grid item xs={12} sm={3}>
                        <FormControl fullWidth>
                            <InputLabel htmlFor="input-filial">Filial</InputLabel>
                            <Select
                                native
                                label="Filial"
                                value={filters.idFilial}
                                disabled={idFilialUsuario > 0}
                                onChange={(event) => {
                                    setFilters({ ...filters, idFilial: event.target.value })
                                }}
                                inputProps={{
                                    name: 'idFilial',
                                    id: 'input-filial',
                                }}
                                size="small"
                            >
                                {idFilialUsuario <= 0 && <option key={0} value={0}>{"(Todas)"}</option>}
                                {listFiliales.map((row) => (
                                    <option key={row.id} value={row.id}>{row.descripcion}</option>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={6} sm={3}>
                        <TextField
                            name="member"
                            label="Participante"
                            value={filters.member}
                            fullWidth
                            onChange={(event) => {
                                setFilters({ ...filters, member: event.target.value })
                            }}
                            onKeyDown={(event) => {
                                if (event.key === "Enter") {
                                    event.preventDefault();
                                    fetchResults();
                                }
                            }}
                            size="small"
                        />
                    </Grid>
                    <Grid item xs={6} sm={3}>
                        <TextField
                            name="therapist"
                            label="Terapeuta"
                            value={filters.therapist}
                            fullWidth
                            onChange={(event) => {
                                setFilters({ ...filters, therapist: event.target.value })
                            }}
                            onKeyDown={(event) => {
                                if (event.key === "Enter") {
                                    event.preventDefault();
                                    fetchResults();
                                }
                            }}
                            size="small"
                        />
                    </Grid>
                    <Grid item xs={2} sm={2}>
                        <Button variant="outlined" onClick={() => {
                            fetchResults()
                        }} fullWidth>
                            {<Hidden smDown>Buscar</Hidden>}
                            <IconSearch />
                        </Button>
                    </Grid>
                    <Grid item xs={12} sm={12}>
                        <DataGrid
                            rows={results}
                            columns={columns}
                            initialState={{
                                pagination: {
                                paginationModel: {
                                    pageSize: 5,
                                },
                                },
                            }}
                            pageSize={5}
                            pageSizeOptions={[5]}
                            disableColumnMenu
                            components={{
                                Toolbar: CustomToolbar,
                                LoadingOverlay: CustomLoadingOverlay,
                            }}
                            loading={cargando}
                            rowHeight={25}
                            // Sin checkboxes: la fila se resalta con un clic y se
                            // elige con doble clic o con el boton Aceptar.
                            disableRowSelectionOnClick={false}
                            onRowClick={(params) => setFilaElegida(params.row)}
                            onRowDoubleClick={(params) => {
                                props.setSelection(params.row);
                                props.openClose()
                            }}
                            autoHeight={true}
                            sx={{
                                "& .MuiDataGrid-columnHeader": {
                                backgroundColor: "#1976d2",
                                color: "white",
                                }
                            }}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button color="primary" disabled={!filaElegida} onClick={() => {
                    if (filaElegida) {
                        props.setSelection(filaElegida);
                        props.openClose()
                    }
                }}>Aceptar</Button>
                <Button onClick={() => { props.openClose() }} >Cancelar</Button>
            </DialogActions>
        </Dialog>
    )
}

export default TerapiaSearch;